module.exports = __webpack_public_path__ + "static/media/35.41d1f2b3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/35.svg
// module id = 146
// module chunks = 0